import "@Styles/mandate.css";
import React, { useEffect, useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import Modal from "react-modal"; // 🔹 NEW
import { connect } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { registerUser } from "../../../../Redux/Authenticate/action";
import ToastMsg from "../../../../helper/ToastMsg";
import {
  emailOtpVerify,
  emailVerify,
  getUserDetail,
  signInUser,
} from "../../../../Redux/GeneralDetails/action";

const NewUserEmail = (props) => {
  const navigate = useNavigate();

  // 🔹 NEW: props for popup + callback
  const { isOpen, onRequestClose, onOtpSent } = props;

  const token = props?.user?.token || localStorage.getItem("gpay_token");
  const phone_number = props?.user?.phone_number;

  const [state, setState] = useState({
    displaySignInModal: true,
    isLoading: false,
  });

  let [error, seterror] = useState(null);
  let [loader, setLoader] = useState(false);

  const [acceptTandC, setacceptTandC] = useState(false);
  const [Error, setError] = useState(null);
  const [btnDisable, setBtnDisable] = useState(false);
  const [data, setData] = useState();
  const [res, setRes] = useState();
  const [email, setEmail] = useState("");
  const [is_user_new, setIsUserNew] = useState(true);
  const emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;
  const [enterMPIN, setMPIN] = useState("");

  const acceptTermsAndCond = (props) => {
    setError(null);
    setacceptTandC(!acceptTandC);
  };

  const submitNewEmail = (e) => {
    setLoader(true);
    const phone_number = localStorage.getItem("phone_number");

    e.preventDefault();
    let data = {
      email: email,
      phone_number: Number(localStorage.getItem("phone_number")),
    };

    props
      .emailVerify(data)
      .then((res) => {
        setBtnDisable(true);
        setLoader(false);

        // Save email to localStorage so VerifyOtpemail can access it
        localStorage.setItem("email", email);

        // 🔹 NEW: if parent passed onOtpSent → open popup instead of redirect
        if (typeof onOtpSent === "function") {
          onOtpSent(email, phone_number);
        } else {
          // 🔹 Old behaviour (backward compatible)
          navigate(
            `/emailotpverify?email=${email}&phone_number=${phone_number}`
          );
        }
      })
      .catch((err) => {
        setLoader(false);
        ToastMsg(err?.response?.data?.error, "error");
      });
  };

  const handlSetEmail = (e) => {
    const { value } = e.target;

    setEmail(value);

    if (emailRegex.test(value)) {
      localStorage.setItem("email", value);
    } else {
      localStorage.removeItem("email");
    }
  };

  const responseGoogle = (response) => {
    if (!acceptTandC) {
      setError("Please accept terms and conditions");
      return;
    }

    let data = {
      type: "google",
      access_token: response.tokenId,
      phone_number: Number(localStorage.getItem("phone_number")),
    };
    props
      .registerUser(data)
      .then((res) => {
        props
          .getUserDetail(res?.data?.data?.token)
          .then((res) => {
            let nv_data = res?.data?.data?.customusermodel;

            let user_data_nv = {
              mobile: nv_data?.phone_number,
              email: res?.data?.data?.email,
              name: nv_data?.first_name + " " + nv_data?.last_name,
              "preferred language": "en",
              registrationStartDate: res.data.data.created_at,
            };

            let user_data = {
              mobile: `91${nv_data.phone_number}`,
              gender: nv_data?.gender,
              birth_date: nv_data?.date_of_birth,
              "preferred language": "en",
              registrationStartDate: res.data.data.created_at,
              email: res?.data?.data?.email,
              name: nv_data?.first_name + " " + nv_data?.last_name,
            };

            let result_nv = nv_data?.gender ? user_data : user_data_nv;

            nv("user", res?.data?.data?.id, result_nv);

            nv(
              "event",
              "Email Id Registeration",
              {
                mobile: `91${nv_data.phone_number}`,
                email: res?.data?.data?.email,
                name: nv_data?.first_name + " " + nv_data?.last_name,
                "preferred language": "en",
              },
              "100",
              1
            );
          })
          .catch((err) => {
            if (error?.response?.status === 401) {
              window.location.href = "/";
              localStorage.removeItem("gpay_token");
            }
            let error = err?.response?.data?.error;
            ToastMsg(error, "error");
          });
      })
      .catch((err) => {
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        if (err.response.status === 401) {
          navigate("/");
        }
        setLoader(false);
      });
  };

  const submitMpin = () => {
    let mpin = parseInt(enterMPIN);
    let data = {
      phone_number,
      mpin,
    };
    props
      .signInUser(data)
      .then((res) => {
        nv("event", "LoginResult", { Login: true }, "100", 1);
        if (res.status === 200) {
          let token = res.data && res.data.data.token;
          props.saveManualToken(token);
          props.savePhoneNumber({ phone_number: phone_number });

          props
            .getUserDetail(token)
            .then((res) => {
               
              let nv_data = res?.data?.data?.customusermodel;

              let user_data_nv = {
                mobile: nv_data?.phone_number,
                email: res?.data?.data?.email,
                name: nv_data?.first_name + " " + nv_data?.last_name,
                registrationStartDate: res.data.data.created_at,
                "preferred language": "en",
              };

              let user_data = {
                mobile: `91${nv_data.phone_number}`,
                gender: nv_data?.gender,
                birth_date: nv_data?.date_of_birth,
                "preferred language": "en",
                registrationStartDate: res.data.data.created_at,
                email: res?.data?.data?.email,
                name: nv_data?.first_name + " " + nv_data?.last_name,
              };

              let result_nv = nv_data?.gender ? user_data : user_data_nv;

              nv("user", res?.data?.data?.id, result_nv);
            })
            .catch((err) => {
              setLoader(false);
              if (err.response?.status === 401) {
                window.location.href = "/";
                localStorage.removeItem("gpay_token");
              }
              let error = err?.response?.data?.error;
              ToastMsg(error, "error");
            });

          props
            .getDocumentStatus(token)
            .then((res) => {
              res.data.map((details) => {
                if (details.cibil_form) {
                  if (details.karza) {
                    navigate("/karza");
                  } else {
                    navigate("/creditlimit");
                  }
                } else {
                   
                  navigate("/dashboard_s");
                }
              });
            })
            .catch((err) => {
              setLoader(false);
              if (err.response?.status === 401) {
                window.location.href = "/";
                localStorage.removeItem("gpay_token");
              }
              let error = err?.response?.data?.error;
              ToastMsg(error, "error");
            });
        } else {
          ToastMsg(res?.data?.error, "error");
        }
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
      });
  };

  useEffect(() => {
    const savedEmail = localStorage.getItem("email");
    if (savedEmail) {
      setEmail(savedEmail);
    } else {
      console.error("Email not found in localStorage");
    }
  }, []);

  const responseGoogleFail = () => {
    setLoader(false);
    setError("Unable to Sign up, please try again");
  };

  // 🔹 Common content (used for page + popup)
  const Content = (
    <div id="dashboardbackground" className="main_div">
      <div className="">
        <div className="pb-4">
          <div className="topmargincontainer wrapper-content container">
            <div className=" pb-3 pt-1 w-100 text-center mx-auto rounded-40">
              <div className="h-100 d-flex flex-column justify-content-between">
                <div className="emailtransformfix ">
                  <div
                    style={{
                      textAlign: "center",
                      margin: "auto",
                    }}
                  ></div>

                  <span className="entermail font-size-18">Email ID</span>
                  <br />
                  <br />

                  <div className="input-wrapper dispflexaligncentre">
                    <input
                      className="input emailfontNewEmail EmailVerifytext "
                      onChange={handlSetEmail}
                      value={email}
                      type="text"
                      name="notgmailemail"
                      placeholder=" "
                      style={{ marginLeft: "0 !important" }}
                    />
                    <label style={{ marginLeft: 20 }} className="label">
                      Enter Email ID
                    </label>
                  </div>

                  <br />
                  <br />
                  <br /> <br />
                  <br />

                  <div className="alignbtncenter stickeybottomsign ">
                    {email.length ? (
                      <div
                        style={{ marginLeft: 0 }}
                        className="newbtnDesignotp GetotpSize text-white"
                        onClick={
                          !btnDisable
                            ? is_user_new
                              ? submitNewEmail
                              : submitMpin
                            : null
                        }
                        disabled={btnDisable}
                      >
                        Get OTP
                      </div>
                    ) : (
                      <div
                        style={{ marginLeft: 0 }}
                        className="newbtnDesignotp GetotpSize text-white "
                        disabled
                      >
                        Get OTP
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // 🔹 If used as popup (like you asked)
  if (typeof isOpen === "boolean") {
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        className="otp-main-modal"        // reuse same modal styles if you want
        overlayClassName="otp-main-overlay"
        ariaHideApp={false}
      >
        {Content}
      </Modal>
    );
  }

  // 🔹 Original full-page behaviour
  return <>{Content}</>;
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
export default connect(mapStateToProps, {
  registerUser,
  signInUser,
  getUserDetail,
  emailVerify,
  emailOtpVerify,
})(NewUserEmail);
